import type { RootState } from "@/src/common/redux/store";

export const getUnreadCount = (state: RootState) => state.message.unreadCount;
